import React from "react"
import { useLocation, useParams } from "react-router-dom"
import { BreadcrumbComponent } from "../../components/common/breadcrumb"
import { TasksComponent } from "../../components/dbTasks"
import { DefaultPageComp } from "../../components/defaultPage"

export const DbTasksPage = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const refresh = searchParams.get('refresh');
  return <>
    <DefaultPageComp>
      <BreadcrumbComponent />
      <TasksComponent refresh={refresh === 'true'} />
    </DefaultPageComp>
  </>
}